// extracted by mini-css-extract-plugin
export default {"DropdownItem":"Dropdown_DropdownItem__LvA1H","Absolute":"Dropdown_Absolute__CX3mK"};